// extracted by mini-css-extract-plugin
module.exports = {"tabs":"SettingsMenu_tabs__uq0cC","tab":"SettingsMenu_tab__Pfa2A"};